/*
 * Sticky add-to-cart bar.
 *
 * The bar owns no state of its own. It mirrors the real buy box: the price it
 * shows is the text Dawn is already rendering into the live price node, and
 * the button forwards a click to the real submit button inside the real
 * product form. That is deliberate. A bar that kept its own copy of the price,
 * or built its own /cart/add request, would drift the moment a variant changed
 * or an app modified the form, and would show the shopper a number that was
 * not the number they were charged.
 *
 * Consequence worth knowing: everything the bar can display is already true on
 * the page. It cannot invent a price, a saving or an availability.
 */
(function () {
  'use strict';

  var bar = document.querySelector('[data-az-stickybuy]');
  if (!bar) return;

  var info = document.querySelector('.product__info-container');
  var submit =
    (info && info.querySelector('.product-form__submit')) ||
    document.querySelector('.product-form__submit');
  var anchor = document.querySelector('.product-form__buttons');
  var priceNode = info ? info.querySelector('[id^="price-"]') : null;

  if (!submit || !anchor) return;

  var out = bar.querySelector('[data-az-stickybuy-price]');
  var btn = bar.querySelector('[data-az-stickybuy-go]');

  /* ----------------------------------------------------------- mirroring */

  /*
   * Visible to the eye, not to textContent.
   *
   * Dawn's price block carries a screen-reader label beside every number and
   * both badges at all times, showing whichever the CSS allows. textContent
   * cannot see CSS, so it returned the lot and the bar read
   *
   *   Regular price $100.00 USD Regular price $135.00 USD Sale price
   *   $100.00 USD Sale Sold out
   *
   * on a product that is simply $100, down from $135, and in stock.
   *
   * So the numbers are taken from the .price-item nodes that are actually
   * being drawn -- which is also what drops the labels, the badges and the
   * half of the block the CSS is hiding -- and the whole-node read stays as a
   * fallback for a price block that has no .price-item in it at all, with the
   * labels taken out of a clone first. Mirroring is still the rule: every
   * number here is one the buy box is already showing.
   */
  var drawn = function (el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  };

  var syncPrice = function () {
    if (!out || !priceNode) return;

    var seen = {};
    var items = Array.prototype.slice
      .call(priceNode.querySelectorAll('.price-item'))
      .filter(drawn)
      .filter(function (el) {
        var t = el.textContent.replace(/\s+/g, ' ').trim();
        if (!t || seen[t]) return false;
        seen[t] = true;
        return true;
      });

    if (!items.length) {
      var clone = priceNode.cloneNode(true);
      Array.prototype.slice
        .call(clone.querySelectorAll('.visually-hidden, .visually-hidden--inline'))
        .forEach(function (n) { n.parentNode.removeChild(n); });
      var flat = clone.textContent.replace(/\s+/g, ' ').trim();
      if (flat && out.textContent !== flat) out.textContent = flat;
      return;
    }

    /*
     * Sale price first, was-price struck after it.
     *
     * Taken as flat text the bar read "$135.00 USD $88.00 USD", which is two
     * numbers with nothing to say which one the shopper pays -- and the larger
     * one came first. Dawn's own block draws the compare-at inside an <s>; the
     * bar has to rebuild that, because it reads the numbers out of those nodes
     * rather than moving them.
     */
    var text = function (el) { return el.textContent.replace(/\s+/g, ' ').trim(); };
    var sale = [];
    var was = [];
    items.forEach(function (el) {
      if (el.classList.contains('price-item--sale')) sale.push(text(el));
      else was.push(text(el));
    });

    /* Not on sale: one regular price, and it is what is paid. */
    if (!sale.length) { sale = was; was = []; }

    var html = sale
      .map(function (t) { return '<span class="az-stickybuy__now"></span>' + t; })
      .concat(was.map(function (t) { return '<s class="az-stickybuy__was"></s>' + t; }))
      .join('');

    if (out.getAttribute('data-az-price') === html) return;
    out.setAttribute('data-az-price', html);

    out.textContent = '';
    sale.forEach(function (t) {
      var n = document.createElement('span');
      n.className = 'az-stickybuy__now';
      n.textContent = t;
      out.appendChild(n);
    });
    was.forEach(function (t) {
      var n = document.createElement('s');
      n.className = 'az-stickybuy__was';
      n.textContent = t;
      out.appendChild(n);
    });
  };

  var syncButton = function () {
    if (!btn) return;
    var label = submit.querySelector('span');
    var text = (label ? label.textContent : submit.textContent).replace(/\s+/g, ' ').trim();
    if (text) btn.textContent = text;
    btn.disabled = submit.disabled;
  };

  var sync = function () {
    syncPrice();
    syncButton();
  };

  sync();

  if (window.MutationObserver) {
    var watch = new MutationObserver(sync);
    if (priceNode) watch.observe(priceNode, { childList: true, subtree: true, characterData: true });
    watch.observe(submit, { attributes: true, childList: true, subtree: true });
  }

  /* The variant picker replaces the whole section on some Dawn setups. */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects, .product-form__input')) {
      window.setTimeout(sync, 120);
    }
  });

  /* ------------------------------------------------------------- showing */

  var show = function (on) {
    if (bar.hidden === !on) return;
    bar.hidden = !on;
  };

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          /*
           * Only once the real button has scrolled off the TOP. While it is
           * still below the fold the shopper has not reached the buy box yet,
           * and covering the page with a second one is noise.
           */
          var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          show(passed);
        });
      },
      { threshold: 0 }
    );
    io.observe(anchor);
  }

  /* -------------------------------------------------------------- acting */

  if (btn) {
    btn.addEventListener('click', function () {
      if (submit.disabled) return;
      /* Dawn's own cart drawer or notification takes it from here. */
      submit.click();
    });
  }
})();
